interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      {icon && (
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[vargray-100] flex items-center justify-center text-[vargray-400] text-3xl">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-medium text-[vargray-800] mb-2">{title}</h3>
      {description && (
        <p className="text-sm text-[vargray-500] mb-6 max-w-md mx-auto">{description}</p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="px-4 py-2 bg-[varsec] text-white rounded-lg hover:bg-[varsec]/90 transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
